import { render, staticRenderFns } from "./aboutCards.vue?vue&type=template&id=769e42e5&"
import script from "./aboutCards.vue?vue&type=script&lang=js&"
export * from "./aboutCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769e42e5')) {
      api.createRecord('769e42e5', component.options)
    } else {
      api.reload('769e42e5', component.options)
    }
    module.hot.accept("./aboutCards.vue?vue&type=template&id=769e42e5&", function () {
      api.rerender('769e42e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/aboutCards.vue"
export default component.exports